module.exports = __webpack_public_path__ + "static/media/redhat.c74a8f11.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/redhat.png
// module id = 178
// module chunks = 0